import axios from 'axios';
import getUserToken from './getUserToken';

const getUserInfo = async () => axios.get(`/webapi/v1/users/info?api_key=${getUserToken()}`)
  .then((data) => data)
  .catch((error) => console.log(error.message));

export default getUserInfo;
